import { Icon } from '@iconify/react';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom';
import Logo  from "../../Images/AULOGO.png";
import { useLanguage } from '../../i18n';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerTop}>
          {/* Brand */}
          <div className={styles.brand}>
            <Link to="/" className={styles.logo}>
              <img
                src={Logo}
                alt="AU EU Voices Lab Logo"
                className={styles.logoImage}
              />
              {/* <span className={styles.logoText}>AU EU Voices Lab</span> */}
            </Link>
            {/* <Icon icon="fa-solid:shield-alt" className={styles.logo} /> */}
            <span className={styles.name}>AU EU Voices Lab</span>
            <p className={styles.tagline}>{t('tagline')}</p>
          </div>

          {/* Links */}
          <div className={styles.linksGrid}>
            <div className={styles.column}>
              <h4>{t('footerResources')}</h4>
              <Link to="/collections">{t('collectionsTitle')}</Link>
              <Link to="/search">{t('search')}</Link>
              <Link to="/submit-resource">{t('submitResourceTitle')}</Link>
            </div>

            <div className={styles.column}>
              <h4>{t('footerSupport')}</h4>
              <Link to="/support">{t('supportDirectory')}</Link>
              <Link to="/my-resources">{t('myResources')}</Link>
              {/* <a href="#">{t('helpCenter') || 'Help Center'}</a> */}
            </div>

            <div className={styles.column}>
              <h4>{t('footerAccount')}</h4>
              <Link to="/account-settings">{t('accountSettings')}</Link>
              <a href="#">{t('privacy')}</a>
              <a href="#">{t('signOut')}</a>
            </div>
          </div>

          {/* Emergency */}
          {/* <div className={styles.emergency}>
            <h4>{t('emergencySupportTitle')}</h4>
            <div className={styles.hotline}>
              <Icon icon="lucide:phone" className={styles.phoneIcon} />
              <div>
                <strong>{t('crisisHotline')}</strong>
                <p>{t('crisisHotlineSubtitle')}</p>
              </div>
            </div>
            <Link to="/support" className={styles.emergencyBtn}>
              {t('getHelpNow')}
            </Link>
          </div> */}
        </div>

        <div className={styles.footerBottom}>
          <p>© {new Date().getFullYear()} AU EU Voices Lab. All rights reserved.</p>
          <div className={styles.bottomLinks}>
            <a href="#">{t('privacy')}</a>
            <span>•</span>
            <a href="#">{t('terms')}</a>
            <span>•</span>
            <a href="#">{t('contact')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
// import { Icon } from '@iconify/react';
// import styles from './Footer.module.css';

// export default function Footer() {
//   return (
//     <footer className={styles.footer}>
//       <div className={styles.footerContainer}>
//         {/* Top section - brand + links + emergency */}
//         <div className={styles.footerTop}>
//           {/* Brand / Logo column */}
//           <div className={styles.footerBrand}>
//             <div className={styles.footerLogoWrapper}>
//               <Icon icon="fa-solid:shield-alt" className={styles.footerLogo} />
//             </div>
//             <span className={styles.footerName}>SafeGuard Resource Hub</span>
//             <p className={styles.footerTagline}>
//               Built for activists, by activists
//             </p>
//             <p className={styles.copyright}>
//               © {new Date().getFullYear()} SafeGuard Resource Hub. All rights reserved.
//             </p>
//           </div>

//           {/* Links columns */}
//           <div className={styles.footerLinksGrid}>
//             <div className={styles.linkColumn}>
//               <h4>Resources</h4>
//               <a href="#">Browse All Resources</a>
//               <a href="#">Digital Security Guides</a>
//               <a href="#">Legal & Advocacy Tools</a>
//               <a href="#">Collections & Bundles</a>
//               <a href="#">Submit a Resource</a>
//             </div>

//             <div className={styles.linkColumn}>
//               <h4>Support</h4>
//               <a href="#">Help Center</a>
//               <a href="#">Community Forum</a>
//               <a href="#">Emergency Contacts</a>
//               <a href="#">Report an Issue</a>
//             </div>

//             <div className={styles.linkColumn}>
//               <h4>Account</h4>
//               <a href="#">My Resources</a>
//               <a href="#">Account Settings</a>
//               <a href="#">Privacy & Security</a>
//               <a href="#">Sign Out</a>
//             </div>
//           </div>

//           {/* Emergency support box */}
//           <div className={styles.emergencySupport}>
//             <h4>Emergency Support</h4>
//             <div className={styles.hotlineCard}>
//               <div className={styles.hotlineIconWrapper}>
//                 <Icon icon="lucide:phone" className={styles.hotlineIcon} />
//               </div>
//               <div className={styles.hotlineText}>
//                 <strong>Crisis Hotline</strong>
//                 <p>24/7 emergency support available</p>
//               </div>
//             </div>
//             <button className={styles.emergencyButton}>
//               Get Help Now
//             </button>
//           </div>
//         </div>

//         {/* Bottom bar */}
//         <div className={styles.footerBottom}>
//           <div className={styles.bottomLeft}>
//             <span>Built with care for human rights defenders</span>
//           </div>
//           <div className={styles.bottomRight}>
//             <a href="#">Privacy Policy</a>
//             <span>•</span>
//             <a href="#">Terms of Use</a>
//             <span>•</span>
//             <a href="#">Contact Us</a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }